export default {
    name: '営業所名称',
    telno: '電話番号',
    sortno: '並び順',
    kyokacode: '建設業許可者',
    kyokano: '許可番号',
    kyokadate: '許可年月日',
    industries: '建設業種別'
};
